import { BranchMonthlyRevenueByState } from './branch-monthly-revenue-bystate';
import { customElement } from 'lit/decorators.js';
import { LangDashboardBranchMonthlyRevenuePipeline } from '../../../../localization/scripts/dealer-franchisee/dashboard/widget/branch-monthly-revenue-pipeline-lang';
import { QuoteState } from '../../../api/dealer-api-interface-quote';
import { Snippet } from '../../../../webmodule-common/other/ui/events';

@customElement('dashboard-branch-monthly-revenue-pipeline')
export class BranchMonthlyRevenuePipeLine extends BranchMonthlyRevenueByState {
  protected async firstUpdated(): Promise<void> {
    this.state = QuoteState.Issued;
    // Remove immediate data call; template rendering handles data fetch safely
  }

  protected getHeader(): Snippet {
    return LangDashboardBranchMonthlyRevenuePipeline.monthlyRevenuePipeline();
  }
}
